import { CommonModule } from "@angular/common";
import { Component, OnInit } from "@angular/core";
import { GoogleMapsModule } from "@angular/google-maps";
import { Router, RouterLink } from "@angular/router";
import { environment } from "src/environments/environment";
import { API_URLS } from "../../config/app.constants";
import { AuthService } from "../services/auth.service";
import { HttpinterceptorService } from "../services/httpinterceptor.service";
import { Utils } from "../utils";

@Component({
  selector: "app-footer",
  templateUrl: "./footer.component.html",
  styleUrls: ["./footer.component.scss"],
  standalone: true,
  imports: [CommonModule, RouterLink, GoogleMapsModule],
  providers: [Utils],
})
export class FooterComponent implements OnInit {
  plans;
  currentYear = new Date().getFullYear();

  constructor(
    private http: HttpinterceptorService,
    private router: Router,
    public utils: Utils,
    private auth: AuthService
  ) {
    if (environment.production) {
      this.auth.recordingScriptAfterLogin();
    }
  }

  ngOnInit() {
    this.getPlans();
  }

  getPlans() {
    this.http.post(API_URLS.GET_MENUS, {}, false).subscribe((response) => {
      if (response.data) {
        this.plans = response.data.find(
          (menu) => menu.title === "Wellness Plans"
        );
      }
    });
  }

  goToPlan(plan) {
    let route;

    if (plan.multiple_pet_type) {
      route = `${plan.path}/${plan.submenu[0].slug}`;
    } else {
      route = `${plan.path}`;
    }
    this.router.navigate([route]);
  }
}
